module.exports = __webpack_public_path__ + "img/brush.caa6bc42.svg";